import { Component, input, InputSignal, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';
import {
    AppealRecommendationTemplateService,
    SelectedEmailAttachment,
} from '../../appealRecommendationTemplate.service';
import { HelpTooltipDirective } from '../../../../UI-Lib/Help-Tooltip';

@Component({
    selector: 'attachment-selections',
    templateUrl: './attachmentSelections.component.html',
    styleUrls: ['./attachmentSelections.component.scss'],
    imports: [HelpTooltipDirective],
})
export class AttachmentSelectionsComponent implements OnInit, OnDestroy {
    constructor(private readonly _arccTemplateService: AppealRecommendationTemplateService) {}

    editMode: InputSignal<boolean> = input<boolean>(false);

    selectedAttachments: SelectedEmailAttachment[] = [];

    private _sub: Subscription;

    ngOnInit(): void {
        this._sub = this._arccTemplateService.selectedAttachments$.subscribe((attachments) => {
            this.selectedAttachments = attachments;
        });
    }

    ngOnDestroy(): void {
        this._sub?.unsubscribe();
    }

    removeAttachment(attachment: SelectedEmailAttachment): void {
        this._arccTemplateService.removeSelectedAttachment(attachment.attachmentId);
    }

    /**
     * Formats a byte count into a human-readable string (e.g. "1.2 MB").
     */
    formatFileSize(bytes: number): string {
        if (bytes == null || bytes === 0) {
            return '0 B';
        }

        const units = ['B', 'KB', 'MB', 'GB'];
        const k = 1024;
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        const size = bytes / Math.pow(k, i);

        return `${size % 1 === 0 ? size : size.toFixed(1)} ${units[i] ?? 'GB'}`;
    }
}
